"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearch = void 0;
const react_1 = require("react");
const debounce_1 = __importDefault(require("debounce"));
const client_constants_1 = require("../client/client.constants");
const useSearch = ({ onSearch, options, }) => {
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const { delay = client_constants_1.SEARCH_DELAY, minCharactersAllowed = client_constants_1.MIN_SEARCH_CHARACTERS_ALLOWED, } = options !== null && options !== void 0 ? options : {};
    const onSearchChanged = (0, react_1.useMemo)(() => (0, debounce_1.default)((search) => onSearch(search), delay), [onSearch, delay]);
    const onSearchChange = (0, react_1.useCallback)((e) => {
        const { value } = e.currentTarget;
        setSearchTerm(value);
        if (searchTerm !== value && (!value || value.length >= minCharactersAllowed)) {
            void onSearchChanged(value);
        }
    }, [minCharactersAllowed, onSearchChanged, searchTerm]);
    return {
        searchTerm,
        onSearchChange,
    };
};
exports.useSearch = useSearch;
